module.exports = __webpack_public_path__ + "static/img/eth.7eaf98c7.png";